// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Wz1_","title":"Header_title__2YWJk","left":"Header_left__ot1mC","clinicName":"Header_clinicName__1DWJX"};